import { useEffect, useState } from 'react';
import { Container, Modal, Snackbar } from '@mui/material';
import { Formik } from 'formik';

import Alert from 'src/components/Alert';
import FilterForm from '../FilterForm';

const FilterModal = ({
  open,
  setOpen,
  members,
  setMembers,
  handleValueChange,
  initialValues,
  onReset,
  searchText
}) => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const [sortData, setSortData] = useState([]);
  useEffect(() => {
    if (members?.length > 0) {
      setSortData([...members]);
    }
  }, [members]);

  function sort(sortBy, order) {
    if (sortData?.length < 0) return;
    if (sortBy === 'Full Name') {
      return sortData?.sort((a, b) => {
        const nameA = a.full_name.toLowerCase();
        const nameB = b.full_name.toLowerCase();
        if (order === 'Ascending') {
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
        } else {
          if (nameA < nameB) return 1;
          if (nameA > nameB) return -1;
        }
      });
    } else if (sortBy === 'Father Name') {
      return sortData?.sort((a, b) => {
        const nameA = a.father_name.toLowerCase();
        const nameB = b.father_name.toLowerCase();
        if (order === 'Ascending') {
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
        } else {
          if (nameA < nameB) return 1;
          if (nameA > nameB) return -1;
        }
      });
    } else if (sortBy === 'Height') {
      if (order === 'Ascending') {
        return sortData?.sort((a, b) => a.height - b.height);
      } else {
        return sortData?.sort((a, b) => b.height - a.height);
      }
    } else if (sortBy === 'Height') {
      if (order === 'Ascending') {
        return sortData?.sort((a, b) => a.height - b.height);
      } else {
        return sortData?.sort((a, b) => b.height - a.height);
      }
    } else if (sortBy === 'Weight') {
      if (order === 'Ascending') {
        return sortData?.sort((a, b) => a.weight - b.weight);
      } else {
        return sortData?.sort((a, b) => b.weight - a.weight);
      }
    } else if (sortBy === 'Membership Start Date') {
      return sortData.sort((a, b) => {
        const dateA = new Date(a.membership_start_date);
        const dateB = new Date(b.membership_start_date);
        if (order === 'Ascending') {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      });
    }

    if (sortBy === 'Membership End Date') {
      return sortData.sort((a, b) => {
        const dateA = new Date(a.membership_end_date);
        const dateB = new Date(b.membership_end_date);
        if (order === 'Ascending') {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      });
    } else {
      return sortData;
    }
  }

  function FilterMembers(filterBy, name, sortBy, order) {
    let sortedArray = sort(sortBy, order);
    if (searchText !== undefined) {
      sortedArray = sortedArray?.filter((member) =>
        member.full_name
          .toLowerCase()
          .includes(searchText?.trim()?.toLowerCase())
      );
    }
    if (filterBy === 'Membership Plan') {
      setMembers(sortedArray?.filter((item) => item.plan.name === name));
    } else if (filterBy === 'Batch') {
      setMembers(sortedArray?.filter((item) => item.batch.name === name));
    } else if (filterBy === 'Trainer') {
      setMembers(sortedArray?.filter((item) => item.trainer.name === name));
    } else if (filterBy === 'Gender') {
      setMembers(sortedArray?.filter((item) => item.gender === name));
    } else {
      setMembers(sortedArray);
    }
  }

  useEffect(() => {
    if (searchText !== undefined) {
      FilterMembers(
        initialValues.filterBy,
        initialValues.name,
        initialValues.sortBy,
        initialValues.sortOrder
      );
    }
  }, [searchText]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Modal
        maxWidth="sm"
        sx={{ overflow: 'scroll', padding: '1rem' }}
        open={open}
        onClose={setOpen}
      >
        <Container
          maxWidth="sm"
          sx={{
            padding: '.8rem',
            backgroundColor: 'background.default',
            borderRadius: '10px'
          }}
        >
          <Formik
            initialValues={
              initialValues
                ? initialValues
                : {
                    filterBy: '',
                    name: '',
                    sortBy: '',
                    sortOrder: ''
                  }
            }
            onSubmit={async (values) => {
              FilterMembers(
                values.filterBy,
                values.name,
                values.sortBy,
                values.sortOrder
              );
              setOpen();
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              touched,
              values
            }) => (
              <FilterForm
                errors={errors}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                touched={touched}
                values={values}
                handleCloseModal={setOpen}
                heading={'Filter Members'}
                handleValueChange={handleValueChange}
                setOpen={setOpen}
                onReset={onReset}
              />
            )}
          </Formik>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarState.open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <div>
              <Alert onClose={handleClose} severity={snackbarState.severity}>
                {snackbarState.message}
              </Alert>
            </div>
          </Snackbar>
        </Container>
      </Modal>
    </>
  );
};

export default FilterModal;
